import Vue from 'vue'
import { path } from './helpers'

const client = function () {
  return Vue.prototype.$api
}

export default {
  getFreedomAndFlowUrl () {
    return client().prototype.$api.get(path('webapp/patients/services/freedom-urls'))
  },
  getWellwoUrl (returnPath = '') {
    return client().get(path('webapp/patients/services/wellwo-urls'), { params: { path: returnPath } })
  },
  getRehBodyUrl () {
    return client().get(path('webapp/patients/services/rehbody-urls'))
  }
}



// WEBPACK FOOTER //
// ./src/repositories/CompanyServicesRepository.js